module.exports = __webpack_public_path__ + "media/images/theme/default/logo-small-b633b7936cae73d19fac722dcefd0f37.png";